

















import { Component, Vue, Prop } from 'vue-property-decorator';
// import SBProMenuLandings from '@structural/menu-landings.vue';
import SBProMenuPages from '@structural/menu-pages.vue';

@Component({
    components: {
        // 'sbpro-menu-landings': SBProMenuLandings,
        'sbpro-menu-pages': SBProMenuPages,
    },
})
export default class TopNavRes extends Vue {
    @Prop({ default: 'fixed-top' }) private topNavClasses!: string;
    @Prop({ default: 'text-primary' }) private brandClasses!: string;
    @Prop({ default: 'btn-primary' }) private buttonClasses!: string;

    isTransparentFixed = true;
    scrolledClassAdded = false;

    get topNavClassesComputed() {
        if (this.scrolledClassAdded) {
            return `${this.topNavClasses} navbar-scrolled`;
        }
        return this.topNavClasses;
    }

    mounted() {
        if (
            this.topNavClasses.match('bg-transparent') &&
            this.topNavClasses.match('fixed-top')
        ) {
            this.isTransparentFixed = true;
        }

        window.document.body.onscroll = () => {
            if (!this.isTransparentFixed) {
                return;
            }
            if (window.scrollY > 0 && !this.scrolledClassAdded) {
                this.scrolledClassAdded = true;
                return;
            }
            if (window.scrollY === 0) {
                this.scrolledClassAdded = false;
            }
        };
    }
}
